<ng-template #modal>
  <div class="offcanvas-header border-bottom">
    <h4 class="modal-title">{{ "heading-title.add-column" | translate }}</h4>
    <button type="button" class="btn-close" (click)="closeModal()"></button>
  </div>
  <div class="offcanvas-body">
    <div class="d-flex justify-content-between mb-3">
      <div class="form-check form-check-secondary">
        <input class="form-check-input" type="checkbox" id="checkbox-all-columns" (change)="onAllCheckboxChange($event)" [checked]="isAllChecked()" />
        <label class="form-check-label" for="checkbox-all-columns">
          {{ "label-title.all" | translate }}
        </label>
      </div>
    </div>
    @for (item of extraColumns; track $index) {
    <div class="customdashSort-list d-flex justify-content-between mb-2" name="allCustomFields">
      <div class="form-check form-check-secondary">
        <input class="form-check-input" type="checkbox" [id]="'checkbox' + item.key" (change)="onCheckboxChange($event, $index)" [checked]="isChecked(item.key)" />
        <label class="form-check-label" [for]="'checkbox' + item.key">
          {{ item.label }}
        </label>
      </div>
      @if(isShowAddBtn(item)) {
      <a href="javascript:void(0);" id="add-column-item" class="mLauto addBtn" (click)="onColumnAdd(item)">
        <em class="ri-add-line align-bottom me-1"></em> {{ "button-title.add" | translate }}
      </a>
      } @else {
      <a href="javascript:void(0);" id="add-column-item" class="mLauto addBtn" (click)="onColumnRemove(item)">
        <em class="ri-subtract-line align-bottom me-1"></em> {{ "button-title.remove" | translate }}
      </a>
      }
    </div>
    }
    <div class="col-12 pt-2">
      <button type="button" class="btn btn-sm btn-danger me-2" id="add-column" (click)="onColumnAdd()">
        {{ "button-title.add" | translate }}
      </button>
      <button type="button" class="btn btn-sm btn-danger me-2" id="remove-column" (click)="onColumnRemove()">
        {{ "button-title.remove" | translate }}
      </button>
    </div>
  </div>
</ng-template>
